import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    orderedList: {
      paddingInlineStart: "4rem",
      margin: 0,
      display: "flex",
      gap: "2rem",
      flexDirection: "column",
    },
    orderedListItem: {
      counterIncrement: "list-item",
      display: "flex",
      "&::before": {
        content: "counter(list-item)",
        lineHeight: 1,
        minWidth: "2.5rem",
        width: "2.5rem",
        height: "2.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 1.5rem 0 -4rem",
        padding: "0.625rem",
        borderRadius: "1.625rem",
        boxSizing: "border-box",
        textAlign: "center",
        fontWeight: "bold",
        border: "0.1875rem solid",
      },
      "&::marker": {
        content: "''",
      },
    },
    stepSpan: {
      display: "block",
      margin: "0.5rem 0 0",
    },
    linkContainer: {
      marginTop: "1rem",
      display: "flex",
      flexWrap: "wrap",
      gap: "16px",
    },
  },
  { name: "StepList" },
);

export { useStyles };
